import { useEffect, useRef } from 'react';

import { getVideoLink } from './getVideoLink';

import * as S from './styled';

const LazyVideo = ({ dataLocator }: { dataLocator?: string }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const { video, poster } = getVideoLink();

    useEffect(() => {
        const videoEl = videoRef.current;

        if (!videoEl) return;

        const observer = new IntersectionObserver(
            (entries, obs) => {
                const entry = entries[0];

                if (!entry?.isIntersecting) return;
                if (videoEl.src !== video) videoEl.src = video;

                videoEl.load();
                obs.unobserve(videoEl);
            },
            { threshold: 0.25 }
        );

        observer.observe(videoEl);

        return () => observer.disconnect();
    }, [video]);

    return (
        <S.VideoWrapper
            poster={poster || undefined}
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            data-locator={dataLocator}
        >
            Your browser doesn&apos;t support video.
        </S.VideoWrapper>
    );
};

export default LazyVideo;
